import React from 'react';

const PrintIcon = () => {
    return (
        <img src='../../../../images/print.svg' alt='Print' />
    );
}

export default PrintIcon;